export const BIBLIA_ACTIONS = {
  RESTRICCIONES: 'RESTRICCIONES',
  INCIDENCIAS: 'INCIDENCIAS',
  OBSERVACIONES: 'OBSERVACIONES',
  TIPODEUNIDAD: 'TIPODEUNIDAD',
  CONDICIONESMEDICAS: 'CONDICIONESMEDICAS',
  ALERGIAS: 'ALERGIAS'
}
